import { render, staticRenderFns } from "./ChangeProduct.vue?vue&type=template&id=3524b0f0&scoped=true&"
import script from "./ChangeProduct.vue?vue&type=script&lang=js&"
export * from "./ChangeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524b0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3524b0f0')) {
      api.createRecord('3524b0f0', component.options)
    } else {
      api.reload('3524b0f0', component.options)
    }
    module.hot.accept("./ChangeProduct.vue?vue&type=template&id=3524b0f0&scoped=true&", function () {
      api.rerender('3524b0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ProductsPage/ChangeProduct.vue"
export default component.exports